/* RVRN Finish Catalogue — filtering, detail modal, finish selection bridge. */
(function () {
  'use strict';

  var rootSelector = '[data-rvrn-finish-catalogue]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var requestTargetSelector = '[data-rvrn-finish-request]';

  /* the CTA can point at any in-page anchor (for example #contact from a
     "jump" section) rather than the built-in request section */
  function scrollToRequest(anchor) {
    var target =
      (anchor && anchor.charAt(0) === '#' && anchor.length > 1 && document.querySelector(anchor)) ||
      document.querySelector(requestTargetSelector) ||
      document.getElementById('rvrn-finish-request');
    if (!target) return;
    var offset = parseInt(getComputedStyle(target).getPropertyValue('scroll-margin-top'), 10) || 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  function announceFinish(name, handle) {
    document.dispatchEvent(
      new CustomEvent('rvrn:finish:select', {
        bubbles: true,
        detail: { name: name, handle: handle }
      })
    );
  }

  function init(root) {
    if (root.dataset.rvrnFinishCatalogueReady === 'true') return;
    root.dataset.rvrnFinishCatalogueReady = 'true';

    var grid = root.querySelector('[data-catalogue-grid]');
    var toolbar = root.querySelector('[data-catalogue-toolbar]');
    var loadingState = root.querySelector('[data-catalogue-loading]');
    var emptyState = root.querySelector('[data-catalogue-empty]');
    var errorState = root.querySelector('[data-catalogue-error]');
    var resultCount = root.querySelector('[data-result-count]');
    var chipsBox = root.querySelector('[data-chips]');
    var tabsBox = root.querySelector('[data-group-tabs]');
    var typeNav = root.querySelector('[data-type-nav]');

    var emptyLabel = root.getAttribute('data-empty-label') || '';
    var showCaseStatus = root.getAttribute('data-show-case-status') !== 'false';
    var footLabel = root.getAttribute('data-foot-label') || '';
    var allLabel = root.getAttribute('data-all-label') || 'All finishes';
    var corvetteLabel = root.getAttribute('data-corvette-label') || 'Corvette colours';
    var familyTitleSetting =
      root.getAttribute('data-family-title') || 'More Finishes in the {family} Family';
    var familyCopySetting =
      root.getAttribute('data-family-copy') ||
      'Compare other finishes in the {family} family and see how different surface treatments change the look of your build.';
    var familyLinkSetting = root.getAttribute('data-family-link-label') || 'View {family} Finishes';
    var galleryNextLabel = root.getAttribute('data-gallery-next-label') || 'Next Group';
    var galleryCount = Math.min(12, Math.max(1, parseInt(root.getAttribute('data-gallery-count'), 10) || 4));
    var CANONICAL_ORDER = ['Carbon', 'Brushed', 'Polished', 'Solid', 'Corvette', 'Chrome'];

    var finishMap = {};
    var cardNodes = [];
    var groupNodes = [];
    var tabNodes = [];
    var typeLinkNodes = [];

    var state = {
      group: 'all',
      type: {},
      color: {},
      selected: null,
      caseIndex: 0,
      casePage: 0,
      caseShot: 0
    };

    function typeOrderOf(type) {
      var index = CANONICAL_ORDER.indexOf(type);
      return index > -1 ? (index + 1) * 10 : 500;
    }

    /* groups are the Finish Family values; the type is only a fallback for an
       entry that has no family assigned yet */
    function familyOf(item) {
      return item.fam || item.t || 'Other';
    }

    function familyKey(item) {
      return handleizeValue(familyOf(item));
    }

    /* family scope, kept as metadata on the group nodes */
    function isCorvetteFamily(item) {
      return /corvette/i.test(item.fam || item.t || '');
    }

    function scopeOf(item) {
      return isCorvetteFamily(item) ? 'corvette' : 'standard';
    }

    function refreshNodes() {
      cardNodes = Array.prototype.slice.call(root.querySelectorAll('[data-finish-card]'));
      groupNodes = Array.prototype.slice.call(root.querySelectorAll('[data-catalogue-group]'));
      tabNodes = Array.prototype.slice.call(root.querySelectorAll('[data-group-tab]'));
      typeLinkNodes = Array.prototype.slice.call(root.querySelectorAll('[data-jump-type]'));
    }

    function selectedKeys(map) {
      return Object.keys(map).filter(function (key) {
        return map[key];
      });
    }

    function filterValue(card, key) {
      var trigger = card.querySelector('[data-finish-trigger]');
      if (!trigger) return '';
      return key === 'type' ? trigger.dataset.type : key === 'color' ? trigger.dataset.color : trigger.dataset.group;
    }

    function isGroupMatch(card) {
      return state.group === 'all' || filterValue(card, 'group') === state.group;
    }

    function render() {
      var activeTypes = selectedKeys(state.type);
      var activeColors = selectedKeys(state.color);
      var visible = 0;

      cardNodes.forEach(function (card) {
        var ok = isGroupMatch(card);
        if (ok && activeTypes.length) ok = activeTypes.indexOf(filterValue(card, 'type')) > -1;
        if (ok && activeColors.length) ok = activeColors.indexOf(filterValue(card, 'color')) > -1;
        card.hidden = !ok;
        if (ok) visible += 1;
      });

      groupNodes.forEach(function (group) {
        var shown = group.querySelectorAll('[data-finish-card]:not([hidden])').length;
        group.hidden = shown === 0;
        var count = group.querySelector('[data-group-count]');
        if (count) count.textContent = shown + (shown === 1 ? ' finish' : ' finishes');
      });

      if (resultCount) {
        resultCount.textContent = visible + (visible === 1 ? ' finish shown' : ' finishes shown');
      }

      if (emptyState) emptyState.hidden = visible !== 0;
      if (grid) grid.hidden = visible === 0;

      if (chipsBox) {
        chipsBox.innerHTML = '';
        var addChip = function (dimension, value, label) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'rvrn-finish-catalogue__chip';
          chip.dataset.remove = dimension;
          chip.dataset.value = value;
          chip.textContent = label + ' ×';
          chipsBox.appendChild(chip);
        };
        if (state.group !== 'all') {
          var groupTab = tabNodes.filter(function (tab) {
            return tab.dataset.groupTab === state.group;
          })[0];
          addChip('group', 'all', groupTab ? groupTab.textContent.trim() : state.group);
        }
        activeTypes.forEach(function (value) {
          addChip('type', value, value);
        });
        activeColors.forEach(function (value) {
          addChip('color', value, value);
        });
      }

      updateCounts();
      updateTypeLinks(activeTypes);
      applyTabState();
    }

    function updateCounts() {
      ['type', 'color'].forEach(function (dimension) {
        var list = root.querySelectorAll('[data-filter-count]');
        Array.prototype.forEach.call(list, function (node) {
          if (!node.closest('[data-filter-menu="' + dimension + '"]')) return;
          var value = node.dataset.filterCount;
          var total = cardNodes.filter(function (card) {
            return isGroupMatch(card) && filterValue(card, dimension) === value;
          }).length;
          node.textContent = String(total);
        });
      });
    }

    function updateTypeLinks(activeTypes) {
      typeLinkNodes.forEach(function (link) {
        var value = link.dataset.jumpType;
        link.classList.toggle('rvrn-is-active', activeTypes.length === 1 && activeTypes[0] === value);
      });
    }

    function setGroup(group) {
      state.group = group;
      render();
    }

    /* a re-render rebuilds the tabs, so the active state has to be re-applied
       from state.group instead of being baked in at build time */
    function applyTabState() {
      tabNodes.forEach(function (tab) {
        var active = tab.dataset.groupTab === state.group;
        tab.classList.toggle('rvrn-is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
    }

    function clearFilters() {
      state.type = {};
      state.color = {};
      root.querySelectorAll('[data-filter]').forEach(function (input) {
        input.checked = false;
      });
      setGroup('all');
    }

    function closeMenus(except) {
      root.querySelectorAll('[data-filter-menu]').forEach(function (menu) {
        if (menu === except) return;
        menu.classList.remove('is-open');
      });
      root.querySelectorAll('[data-filter-trigger]').forEach(function (trigger) {
        if (except && trigger.dataset.filterTrigger === except.dataset.filterMenu) return;
        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function toggleMenu(dimension) {
      var trigger = root.querySelector('[data-filter-trigger="' + dimension + '"]');
      var menu = root.querySelector('[data-filter-menu="' + dimension + '"]');
      if (!trigger || !menu) return;
      var open = !menu.classList.contains('is-open');
      closeMenus(menu);
      menu.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function scrollToElement(node) {
      if (!node) return;
      var offset = (parseInt(getComputedStyle(root).getPropertyValue('--rvrn-finish-sticky-top'), 10) || 68) + 96;
      window.scrollTo({
        top: node.getBoundingClientRect().top + window.pageYOffset - offset,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    /* the nav lists finish types again; a type can sit in several families, so
       the jump scrolls to the first family that carries it */
    function jumpToType(value) {
      var groupNode = null;
      if (value === 'Corvette') {
        state.type = {};
        root.querySelectorAll('[data-filter="type"]').forEach(function (input) {
          input.checked = false;
        });
        setGroup('corvette');
        groupNode = root.querySelector('[data-catalogue-group][data-group-scope="corvette"]');
      } else {
        state.type = {};
        state.type[value] = true;
        root.querySelectorAll('[data-filter="type"]').forEach(function (input) {
          input.checked = input.value === value;
        });
        var sample = null;
        Object.keys(finishMap).forEach(function (key) {
          if (!sample && finishMap[key].t === value) sample = finishMap[key];
        });
        /* land on the tab that actually holds this type instead of dropping
           back to All */
        setGroup(sample ? scopeOf(sample) : 'all');
        groupNode = sample
          ? root.querySelector('[data-catalogue-group="' + familyKey(sample) + '"]')
          : null;
      }
      scrollToElement(groupNode);
    }

    /* every click is delegated from the section root, so cards rendered after
       the API response respond exactly like server-rendered ones */
    root.addEventListener('click', function (event) {
      var target = event.target;

      var trigger = target.closest('[data-finish-trigger]');
      if (trigger) {
        openModal(trigger.getAttribute('data-finish-trigger'));
        return;
      }

      var tab = target.closest('[data-group-tab]');
      if (tab) {
        setGroup(tab.getAttribute('data-group-tab'));
        return;
      }

      var jump = target.closest('[data-jump-type]');
      if (jump) {
        jumpToType(jump.getAttribute('data-jump-type'));
        return;
      }

      var filterTrigger = target.closest('[data-filter-trigger]');
      if (filterTrigger) {
        toggleMenu(filterTrigger.getAttribute('data-filter-trigger'));
        return;
      }

      if (target.closest('[data-clear-filters]')) {
        clearFilters();
        return;
      }

      if (target.closest('[data-catalogue-retry]')) {
        loadCatalogue();
        return;
      }

      var chip = target.closest('[data-remove]');
      if (chip) {
        var dimension = chip.dataset.remove;
        if (dimension === 'group') {
          setGroup('all');
          return;
        }
        delete state[dimension][chip.dataset.value];
        var input = root.querySelector('[data-filter="' + dimension + '"][value="' + chip.dataset.value + '"]');
        if (input) input.checked = false;
        render();
        return;
      }

      if (!target.closest('[data-filter-wrap]')) closeMenus();
    });

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-filter]');
      if (!input) return;
      var dimension = input.dataset.filter;
      if (!state[dimension]) return;
      if (input.checked) state[dimension][input.value] = true;
      else delete state[dimension][input.value];
      render();
    });

    /* tablist keyboard support: arrows move and select, Home / End jump */
    if (tabsBox) {
      tabsBox.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
        if (!tabNodes.length) return;
        var active = document.activeElement;
        var focused = active && active.closest ? active.closest('[data-group-tab]') : null;
        var current = tabNodes.indexOf(focused);
        if (current === -1) return;
        event.preventDefault();
        var next =
          key === 'Home'
            ? 0
            : key === 'End'
            ? tabNodes.length - 1
            : key === 'ArrowRight'
            ? (current + 1) % tabNodes.length
            : (current - 1 + tabNodes.length) % tabNodes.length;
        tabNodes[next].focus();
        setGroup(tabNodes[next].dataset.groupTab);
      });
    }

    /* ── modal ────────────────────────────────────────────────────────── */
    var modal = root.querySelector('[data-finish-modal]');
    var modalPanel = modal && modal.querySelector('.rvrn-finish-modal__panel');
    var lastFocused = null;

    function setText(node, value) {
      if (node) node.textContent = value || '';
    }

    function fillFamily(template, family) {
      return String(template || '').replace(/\{family\}/gi, family || '');
    }

    function buildCases(item) {
      var host = modal.querySelector('[data-modal-case]');
      if (!host) return;
      host.innerHTML = '';
      host.removeAttribute('aria-busy');
      var cases = casesFor(item);

      if (!cases.length) {
        var emptyTpl = root.querySelector('[data-case-empty-template]');
        if (emptyTpl) host.appendChild(emptyTpl.content.cloneNode(true));
        return;
      }

      var tpl = root.querySelector('[data-case-template]');
      if (!tpl) return;
      host.appendChild(tpl.content.cloneNode(true));

      var detail = host.querySelector('[data-case-detail]');
      var gallery = host.querySelector('[data-case-gallery]');
      var image = host.querySelector('[data-case-image]');
      var linkNode = host.querySelector('[data-case-link]');
      var controls = host.querySelector('[data-case-controls]');
      var navRow = host.querySelector('.rvrn-finish-modal__gallery-nav');
      var counter = host.querySelector('[data-case-counter]');
      var prevButton = host.querySelector('[data-case-prev]');
      var nextButton = host.querySelector('[data-case-next]');
      var groupButton = host.querySelector('[data-case-next-group]');

      /* only builds with a Featured Wheel Image can fill a gallery slot */
      var shots = cases.filter(function (entry) {
        return entry && entry.i;
      });
      var pages = Math.ceil(shots.length / galleryCount);
      if (state.casePage >= pages) state.casePage = 0;

      var pageShots = pages ? shots.slice(state.casePage * galleryCount, state.casePage * galleryCount + galleryCount) : [];
      if (state.caseShot >= pageShots.length) state.caseShot = 0;

      var current = pageShots[state.caseShot] || cases[0] || {};

      if (image) {
        if (current.i) {
          image.src = current.i;
          image.alt = (current.w ? current.w + ' in ' : '') + (item.n || 'RVRN finish');
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }
      }
      /* no matching photo: drop the frame instead of showing an empty grey band */
      if (gallery) gallery.hidden = !current.i;
      if (linkNode) {
        if (current.u) linkNode.href = current.u;
        else linkNode.removeAttribute('href');
      }
      if (detail) {
        if (current.u) detail.href = current.u;
        else detail.remove();
      }
      setText(host.querySelector('[data-case-wheel]'), current.w);
      setText(host.querySelector('[data-case-finish]'), current.f);

      if (controls) {
        var hasArrows = pageShots.length > 1;
        var hasGroups = pages > 1;
        controls.hidden = !hasArrows && !hasGroups;
        /* a group may hold a single photo: keep the counter, centre it */
        if (navRow) navRow.classList.toggle('rvrn-is-solo', !hasArrows);
        if (prevButton) prevButton.hidden = !hasArrows;
        if (nextButton) nextButton.hidden = !hasArrows;
        if (groupButton) {
          groupButton.hidden = !hasGroups;
          groupButton.textContent = galleryNextLabel;
        }
        /* image index inside the current group, over that group's size */
        if (counter) counter.textContent = pageShots.length ? state.caseShot + 1 + '/' + pageShots.length : '';
      }

      [prevButton, nextButton].forEach(function (button) {
        if (!button) return;
        button.addEventListener('click', function () {
          var total = pageShots.length;
          if (total < 2) return;
          state.caseShot =
            button === prevButton ? (state.caseShot - 1 + total) % total : (state.caseShot + 1) % total;
          buildCases(item);
        });
      });

      if (groupButton && pages > 1) {
        groupButton.addEventListener('click', function () {
          /* the last group wraps back to the first one */
          state.casePage = (state.casePage + 1) % pages;
          state.caseShot = 0;
          buildCases(item);
        });
      }
    }

    function showCaseLoading() {
      var host = modal.querySelector('[data-modal-case]');
      if (!host) return;
      var tpl = root.querySelector('[data-case-loading-template]');
      host.innerHTML = '';
      host.setAttribute('aria-busy', 'true');
      if (tpl) host.appendChild(tpl.content.cloneNode(true));
    }

    /* The panel is a fixed overlay, so the live header height has to be
       reserved on top of it or the upper part sits behind a fixed header. */
    var HEADER_SELECTOR =
      '.site-header, .wrapper-header, .wrapper-header-bt, .wrapper-navigation, .wrapper-header .is-sticky, .site-header .is-sticky';

    function headerOffset() {
      var offset = 0;
      var viewport = window.innerHeight || 0;
      if (!viewport) return 0;
      Array.prototype.forEach.call(document.querySelectorAll(HEADER_SELECTOR), function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.height <= 0) return;
        /* ignore header chrome that has already scrolled out of the top area */
        if (rect.top > viewport * 0.4) return;
        offset = Math.max(offset, Math.round(rect.bottom));
      });
      return Math.max(0, Math.min(offset, Math.round(viewport * 0.5)));
    }

    function syncModalOffset() {
      if (!modal) return;
      modal.style.setProperty('--rvrn-finish-modal-top', headerOffset() + 'px');
    }

    function openModal(handle) {
      if (!handle) return;
      var item = finishMap[handle];
      if (!item || !modal) return;
      state.selected = item;
      state.caseIndex = 0;
      state.casePage = 0;
      state.caseShot = 0;
      lastFocused = document.activeElement;
      syncModalOffset();

      var image = modal.querySelector('[data-modal-image]');
      if (image) {
        if (item.m) {
          image.src = item.m;
          image.alt = item.n + ' finish reference';
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }
      }
      setText(modal.querySelector('[data-modal-media-caption]'), item.n);
      setText(
        modal.querySelector('[data-modal-eyebrow]'),
        (scopeOf(item) === 'corvette' ? 'Corvette colour match' : 'Finish detail') + ' / ' + item.h
      );
      setText(modal.querySelector('[data-modal-title]'), item.n);

      var desc = modal.querySelector('[data-modal-desc]');
      if (desc) {
        desc.textContent = item.d || '';
        desc.hidden = !item.d;
      }

      var specs = modal.querySelector('[data-modal-specs]');
      if (specs) {
        specs.innerHTML = '';
        [
          ['Finish type', item.t],
          ['Colour family', item.c]
        ].forEach(function (pair) {
          var cell = document.createElement('div');
          cell.className = 'rvrn-finish-modal__spec';
          var label = document.createElement('span');
          label.textContent = pair[0];
          var value = document.createElement('span');
          value.textContent = pair[1] || '—';
          cell.appendChild(label);
          cell.appendChild(value);
          specs.appendChild(cell);
        });
      }

      if (caseIndex) {
        buildCases(item);
      } else {
        /* finish examples are resolved on first open so the catalogue itself
           stays a single lightweight render; show the skeleton until then */
        showCaseLoading();
        loadCaseIndex().then(function (index) {
          if (index) caseIndex = index;
          if (modal.hidden || !state.selected || state.selected.h !== item.h) return;
          state.caseIndex = 0;
          state.casePage = 0;
          state.caseShot = 0;
          buildCases(item);
        });
      }

      /* the block only exists when the section setting is on */
      var familyBlock = modal.querySelector('.rvrn-finish-modal__family');
      if (familyBlock) {
        var familyLink = familyBlock.querySelector('[data-modal-family-link]');
        if (item.c) {
          setText(
            familyBlock.querySelector('[data-modal-family-title]'),
            fillFamily(familyTitleSetting, item.c)
          );
          setText(familyBlock.querySelector('[data-modal-family-copy]'), fillFamily(familyCopySetting, item.c));
          setText(familyLink, fillFamily(familyLinkSetting, item.c) + ' →');
          if (familyLink) {
            familyLink.hidden = false;
            familyLink.dataset.family = item.c;
          }
        } else {
          setText(familyBlock.querySelector('[data-modal-family-title]'), '');
          setText(familyBlock.querySelector('[data-modal-family-copy]'), '');
          if (familyLink) familyLink.hidden = true;
        }
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = modal.querySelector('[data-modal-close]');
      if (close) close.focus();

      var url = new URL(window.location.href);
      url.searchParams.set('finish', item.h);
      window.history.replaceState({}, '', url.toString());
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      var url = new URL(window.location.href);
      url.searchParams.delete('finish');
      window.history.replaceState({}, '', url.toString());
    }

    if (modal) {
      var closeButton = modal.querySelector('[data-modal-close]');
      var backdrop = modal.querySelector('[data-modal-backdrop]');
      if (closeButton) closeButton.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);

      modal.addEventListener('click', function (event) {
        var familyLink = event.target.closest('[data-modal-family-link]');
        if (familyLink) {
          var color = familyLink.dataset.family;
          closeModal();
          clearFilters();
          if (color) {
            state.color[color] = true;
            var input = root.querySelector('[data-filter="color"][value="' + color + '"]');
            if (input) input.checked = true;
          }
          render();
          var catalog = root.querySelector('[data-catalogue-toolbar]');
          if (catalog) {
            var offset = (parseInt(getComputedStyle(root).getPropertyValue('--rvrn-finish-sticky-top'), 10) || 68) + 24;
            window.scrollTo({
              top: catalog.getBoundingClientRect().top + window.pageYOffset - offset,
              behavior: reduceMotion.matches ? 'auto' : 'smooth'
            });
          }
          return;
        }

        var useButton = event.target.closest('[data-finish-use]');
        if (useButton && state.selected) {
          var item = state.selected;
          announceFinish(item.n, item.h);

          if (useButton.dataset.formRemote === 'true') {
            var base = useButton.getAttribute('href') || '';
            if (base) {
              var join = base.indexOf('?') > -1 ? '&' : '?';
              var remoteTarget =
                base +
                join +
                'finish=' +
                encodeURIComponent(item.h) +
                '&request_type=' +
                encodeURIComponent('Use an Existing Finish');
              closeModal();
              window.location.href = remoteTarget;
              return;
            }
          }

          event.preventDefault();
          closeModal();
          scrollToRequest(useButton.getAttribute('href'));
          return;
        }

        var requestLink = event.target.closest('[data-request-type]');
        if (requestLink) {
          if (requestLink.dataset.formRemote === 'true') return;
          event.preventDefault();
          if (state.selected) announceFinish(state.selected.n, state.selected.h);
          document.dispatchEvent(
            new CustomEvent('rvrn:finish:request-type', {
              bubbles: true,
              detail: { requestType: requestLink.dataset.requestType }
            })
          );
          closeModal();
          scrollToRequest(requestLink.getAttribute('href'));
        }
      });

      window.addEventListener('resize', function () {
        if (modal && !modal.hidden) syncModalOffset();
      });

      document.addEventListener('keydown', function (event) {
        if (modal.hidden) return;
        if (event.key === 'Escape') {
          closeModal();
          return;
        }
        if (event.key !== 'Tab' || !modalPanel) return;
        var focusable = modalPanel.querySelectorAll(
          'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }


    /* ── rendering from the API payload ──────────────────────────────── */

    function handleizeValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function buildCard(item) {
      var tpl = root.querySelector('[data-finish-card-template]');
      if (!tpl) return null;
      var article = tpl.content.firstElementChild.cloneNode(true);
      var button = article.querySelector('[data-finish-trigger]');
      article.setAttribute('data-handle', item.h);
      button.setAttribute('data-finish-trigger', item.h);
      button.setAttribute('data-type', item.t);
      button.setAttribute('data-color', item.c);
      button.setAttribute('data-group', handleizeValue(item.g));
      button.setAttribute('data-sort', String(item.s));
      button.setAttribute('aria-label', 'Open details for ' + item.n);
      article.querySelector('[data-slot="name"]').textContent = item.n;
      article.querySelector('[data-slot="type"]').textContent = item.t;
      article.querySelector('[data-slot="color"]').textContent = item.c;
      article.querySelector('[data-slot="foot"]').textContent = footLabel || 'View detail';

      var status = article.querySelector('[data-case-status]');
      var indexed = caseIndex && item.h ? caseIndex[item.h] : null;
      var total = indexed ? indexed.total : 0;
      if (status && !showCaseStatus) {
        status.parentNode.removeChild(status);
      } else if (status) {
        if (total > 0) {
          status.textContent = total + ' Finish Example' + (total > 1 ? 's' : '');
          status.classList.add('rvrn-has-case');
        } else if (emptyLabel) {
          status.textContent = emptyLabel;
        } else if (status.parentNode) {
          status.parentNode.removeChild(status);
        }
      }

      var image = article.querySelector('.rvrn-media__image');
      if (item.m && image) {
        image.src = item.m;
        image.alt = item.n;
      } else {
        var media = article.querySelector('.rvrn-finish-card__media');
        if (media && media.parentNode) media.parentNode.removeChild(media);
      }
      return article;
    }

    function distinctTypes(list) {
      var seen = {};
      var values = [];
      list.forEach(function (item) {
        if (!item.t || seen[item.t]) return;
        seen[item.t] = true;
        values.push(item.t);
      });
      return values.sort(function (a, b) {
        return typeOrderOf(a) - typeOrderOf(b);
      });
    }

    /* Finish Family values in sort_order order, keyed by their handle */
    function familyList(list) {
      var byKey = {};
      list.forEach(function (item) {
        var key = familyKey(item);
        if (!key) return;
        if (!byKey[key]) byKey[key] = { key: key, name: familyOf(item), first: item.s, scope: scopeOf(item) };
        byKey[key].first = Math.min(byKey[key].first, item.s);
      });
      return Object.keys(byKey)
        .map(function (key) {
          return byKey[key];
        })
        .sort(function (a, b) {
          return a.first - b.first || a.name.localeCompare(b.name);
        });
    }

    function distinctColors(list) {
      var seen = {};
      var values = [];
      list.forEach(function (item) {
        if (!item.c || seen[item.c]) return;
        seen[item.c] = true;
        values.push(item.c);
      });
      return values.sort(function (a, b) {
        return a.localeCompare(b);
      });
    }

    function buildTab(key, label) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'rvrn-finish-catalogue__tab';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.dataset.groupTab = key;
      if (grid && grid.id) tab.setAttribute('aria-controls', grid.id);
      tab.textContent = label;
      tabsBox.appendChild(tab);
      return tab;
    }

    /* tabs keep the display_group split; the group headings below them are
       Finish Family values */
    function renderTabs(list) {
      if (!tabsBox) return;
      tabsBox.innerHTML = '';

      buildTab('all', allLabel);

      var seen = {};
      list.forEach(function (item) {
        var group = (item.g || '').trim();
        var handle = handleizeValue(group);
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        buildTab(handle, group === 'Corvette' ? corvetteLabel : group);
      });
    }

    function renderTypeNav(list) {
      if (!typeNav) return;
      typeNav.innerHTML = '';
      var types = distinctTypes(list);
      if (hasBucket(list, 'Corvette')) types.push('Corvette');
      types.forEach(function (type) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rvrn-finish-catalogue__type-link';
        button.dataset.jumpType = type;
        button.textContent = type === 'Corvette' ? corvetteLabel : type;
        typeNav.appendChild(button);
      });
    }

    function hasBucket(list, bucket) {
      return list.some(function (item) {
        return (item.g === 'Corvette' ? 'Corvette' : item.t) === bucket;
      });
    }

    function renderFilterMenu(dimension, values) {
      var menu = root.querySelector('[data-filter-menu="' + dimension + '"]');
      if (!menu) return;
      menu.innerHTML = '';
      values.forEach(function (value) {
        var label = document.createElement('label');
        label.className = 'rvrn-finish-catalogue__filter-option';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.value = value;
        input.setAttribute('data-filter', dimension);

        var text = document.createElement('span');
        text.textContent = value;

        var count = document.createElement('small');
        count.setAttribute('data-filter-count', value);

        label.appendChild(input);
        label.appendChild(text);
        label.appendChild(count);
        menu.appendChild(label);
      });
    }

    function renderGroups(list) {
      if (!grid) return;
      var tpl = root.querySelector('[data-finish-group-template]');
      if (!tpl) return;
      grid.innerHTML = '';

      var families = familyList(list);
      var byKey = {};
      list.forEach(function (item) {
        var key = familyKey(item);
        if (!key) return;
        if (!byKey[key]) byKey[key] = [];
        byKey[key].push(item);
      });

      families.forEach(function (family) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-catalogue-group', family.key);
        node.setAttribute('data-group-scope', family.scope);
        node.setAttribute('data-type-order', String(family.first));
        node.querySelector('[data-slot="group-title"]').textContent = family.name;

        var holder = node.querySelector('.rvrn-finish-catalogue__grid-inner');
        (byKey[family.key] || [])
          .slice()
          .sort(function (a, b) {
            return a.s - b.s || a.n.localeCompare(b.n);
          })
          .forEach(function (item) {
            var card = buildCard(item);
            if (card) holder.appendChild(card);
          });
        grid.appendChild(node);
      });
    }

    function renderData(list) {
      var orderRank = {};
      familyList(list).forEach(function (family, index) {
        orderRank[family.key] = index;
      });
      var sorted = list.slice().sort(function (a, b) {
        var ao = orderRank[familyKey(a)] || 0;
        var bo = orderRank[familyKey(b)] || 0;
        if (ao !== bo) return ao - bo;
        if (a.s !== b.s) return a.s - b.s;
        return a.n.localeCompare(b.n);
      });

      finishMap = {};
      sorted.forEach(function (item) {
        if (item.h) finishMap[item.h] = item;
      });

      renderTabs(sorted);
      renderTypeNav(sorted);
      renderFilterMenu('type', distinctTypes(sorted));
      renderFilterMenu('color', distinctColors(sorted));
      renderGroups(sorted);

      refreshNodes();
      if (!tabNodes.some(function (tab) { return tab.dataset.groupTab === state.group; })) {
        state.group = 'all';
      }
      revealCatalogue();
      render();

      var initial = new URL(window.location.href).searchParams.get('finish');
      if (initial && !state.selected && finishMap[initial]) openModal(initial);
    }

    var FINISH_QUERY =
      'query Finishes($cursor: String) {' +
      ' metaobjects(type: "rvrn_finish", first: 250, after: $cursor) {' +
      ' pageInfo { hasNextPage endCursor }' +
      ' nodes { handle' +
      ' name: field(key: "canonical_name") { value }' +
      ' type: field(key: "finish_type") { value }' +
      ' color: field(key: "color_family") { value }' +
      ' group: field(key: "display_group") { value }' +
      ' family: field(key: "finish_family") { value }' +
      ' sort: field(key: "sort_order") { value }' +
      ' image: field(key: "sample_image") { value }' +
      ' } } }';

    /* Metaobject file_reference fields only expose a GID, so the URLs are
       resolved in a second call. Needs the storefront token to carry
       `unauthenticated_read_product_listings`; without it this rejects and the
       cards render without a swatch image. */
    var MEDIA_QUERY =
      'query Media($ids: [ID!]!) {' +
      ' nodes(ids: $ids) {' +
      ' id' +
      ' ... on MediaImage { image { url(transform: { maxWidth: 600 }) altText } }' +
      ' } }';

    function storefrontRequest(query, variables) {
      var token = root.getAttribute('data-storefront-token');
      var domain = root.getAttribute('data-shop-domain');
      var version = root.getAttribute('data-api-version') || '2024-01';
      if (!token || !domain) return Promise.reject(new Error('storefront_not_configured'));
      return fetch('https://' + domain + '/api/' + version + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: variables || {} })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('http_' + response.status);
          return response.json();
        })
        .then(function (payload) {
          if (payload.errors && payload.errors.length) throw new Error(payload.errors[0].message);
          return payload.data;
        });
    }

    function fetchAllFinishes() {
      var collected = [];
      function next(cursor) {
        return storefrontRequest(FINISH_QUERY, { cursor: cursor || null }).then(function (data) {
          data.metaobjects.nodes.forEach(function (node) {
            collected.push({
              h: node.handle,
              n: node.name && node.name.value ? node.name.value : '',
              t: node.type && node.type.value ? node.type.value.trim() : '',
              c: node.color && node.color.value ? node.color.value.trim() : '',
              g: node.group && node.group.value ? node.group.value.trim() : '',
              fam: node.family && node.family.value ? node.family.value.trim() : '',
              s: parseInt(node.sort && node.sort.value, 10) || 0,
              gid: node.image && node.image.value ? node.image.value : '',
              m: '',
              x: []
            });
          });
          return data.metaobjects.pageInfo.hasNextPage
            ? next(data.metaobjects.pageInfo.endCursor)
            : collected;
        });
      }
      return next(null);
    }

    /* One malformed id rejects the whole nodes(ids:) batch, so a failed batch
       falls back to one request per id and simply drops the bad ones. */
    function resolveChunk(query, ids, collect) {
      return storefrontRequest(query, { ids: ids }).then(
        function (data) {
          collect(data);
        },
        function () {
          return ids.reduce(function (chain, id) {
            return chain.then(function () {
              return storefrontRequest(query, { ids: [id] }).then(collect, function () {});
            });
          }, Promise.resolve());
        }
      );
    }

    function resolveBatched(query, gids, collect) {
      var chunks = [];
      for (var i = 0; i < gids.length; i += 100) chunks.push(gids.slice(i, i + 100));
      return chunks.reduce(function (chain, ids) {
        return chain.then(function () {
          return resolveChunk(query, ids, collect);
        });
      }, Promise.resolve());
    }

    function resolveImages(gids) {
      if (!gids.length) return Promise.resolve({});
      var map = {};
      return resolveBatched(MEDIA_QUERY, gids, function (data) {
        (data.nodes || []).forEach(function (node) {
          if (node && node.image && node.image.url) {
            map[node.id] = { url: node.image.url, alt: node.image.altText || '' };
          }
        });
      }).then(function () {
        return map;
      });
    }

    /* ── finish examples (rvrn_project) ───────────────────────────────── */

    /* `finishes` on a project only points one way, so finish -> project has to
       be resolved by walking every project and matching the reference handles
       back onto the finish currently open in the modal. */
    /* only one gallery page is built at a time, so the cap is a sanity bound,
       not a render cost */
    var CASE_LIMIT = 200;
    var caseIndex = null;
    var caseIndexRequest = null;

    var PROJECT_QUERY =
      'query Projects($cursor: String) {' +
      ' metaobjects(type: "rvrn_project", first: 250, after: $cursor) {' +
      ' pageInfo { hasNextPage endCursor }' +
      ' nodes { handle' +
      ' fin: field(key: "finishes") { references(first: 20) { nodes { ... on Metaobject { handle } } } }' +
      ' img: field(key: "hero_image") { value }' +
      ' wheel: field(key: "wheel") { value }' +
      ' det: field(key: "finish_details") { value }' +
      ' art: field(key: "wheel_gallery_article") { value }' +
      ' prod: field(key: "product") { value }' +
      ' } } }';

    var TARGET_QUERY =
      'query Targets($ids: [ID!]!) {' +
      ' nodes(ids: $ids) { id' +
      ' ... on Article { onlineStoreUrl }' +
      ' ... on Product { onlineStoreUrl }' +
      ' } }';

    function fetchAllProjects() {
      var collected = [];
      function next(cursor) {
        return storefrontRequest(PROJECT_QUERY, { cursor: cursor || null }).then(function (data) {
          data.metaobjects.nodes.forEach(function (node) {
            var refs = node.fin && node.fin.references ? node.fin.references.nodes : [];
            collected.push({
              handles: (refs || [])
                .map(function (ref) {
                  return ref && ref.handle ? ref.handle : '';
                })
                .filter(Boolean),
              img: node.img && node.img.value ? node.img.value : '',
              wheel: node.wheel && node.wheel.value ? node.wheel.value : '',
              det: node.det && node.det.value ? node.det.value : '',
              art: node.art && node.art.value ? node.art.value : '',
              prod: node.prod && node.prod.value ? node.prod.value : ''
            });
          });
          return data.metaobjects.pageInfo.hasNextPage
            ? next(data.metaobjects.pageInfo.endCursor)
            : collected;
        });
      }
      return next(null);
    }

    /* legacy `OnlineStoreArticle` ids and friends are rejected by the API and
       would poison a whole batch, so only the current id shapes are sent */
    var TARGET_ID = /^gid:\/\/shopify\/(Article|Product)\/\d+$/;

    function resolveTargets(gids) {
      var valid = gids.filter(function (gid) {
        return TARGET_ID.test(gid);
      });
      if (!valid.length) return Promise.resolve({});
      var map = {};
      return resolveBatched(TARGET_QUERY, valid, function (data) {
        (data.nodes || []).forEach(function (node) {
          if (node && node.onlineStoreUrl) map[node.id] = node.onlineStoreUrl;
        });
      }).then(function () {
        return map;
      });
    }

    function buildCaseIndex(projects, images, targets) {
      var indexed = {};
      projects.forEach(function (project) {
        if (!project.handles.length) return;
        var image = project.img ? images[project.img] : null;
        var entry = {
          w: project.wheel,
          f: project.det,
          i: image ? image.url : '',
          u: (project.art && targets[project.art]) || (project.prod && targets[project.prod]) || ''
        };
        project.handles.forEach(function (handle) {
          if (!indexed[handle]) indexed[handle] = [];
          indexed[handle].push(entry);
        });
      });
      Object.keys(indexed).forEach(function (handle) {
        var list = indexed[handle];
        /* builds with a photo sort first so each gallery group is filled before
           imageless entries. `total` keeps the untruncated count for the card. */
        list.sort(function (a, b) {
          return (b.i ? 1 : 0) - (a.i ? 1 : 0);
        });
        indexed[handle] = { cases: list.slice(0, CASE_LIMIT), total: list.length };
      });
      return indexed;
    }

    function loadCaseIndex() {
      if (caseIndexRequest) return caseIndexRequest;
      caseIndexRequest = fetchAllProjects()
        .then(function (projects) {
          var imageGids = [];
          var targetGids = [];
          projects.forEach(function (project) {
            if (project.img) imageGids.push(project.img);
            if (project.art) targetGids.push(project.art);
            if (project.prod) targetGids.push(project.prod);
          });
          return Promise.all([
            resolveImages(imageGids).catch(function () {
              return {};
            }),
            resolveTargets(targetGids).catch(function () {
              return {};
            })
          ]).then(function (resolved) {
            return buildCaseIndex(projects, resolved[0], resolved[1]);
          });
        })
        .catch(function () {
          /* let the next open retry instead of caching a failed lookup */
          caseIndexRequest = null;
          return null;
        });
      return caseIndexRequest;
    }

    function casesFor(item) {
      var fromProjects = caseIndex && item.h ? caseIndex[item.h] : null;
      if (fromProjects && fromProjects.cases.length) return fromProjects.cases;
      /* no matching project entry: keep the server-rendered related_projects */
      return (item.x || []).filter(function (entry) {
        return entry && entry.i;
      });
    }

    function setLoading(active) {
      root.setAttribute('aria-busy', active ? 'true' : 'false');
      if (loadingState) loadingState.hidden = !active;
      if (!active) return;
      if (toolbar) toolbar.hidden = true;
      if (grid) grid.hidden = true;
      if (emptyState) emptyState.hidden = true;
      if (errorState) errorState.hidden = true;
    }

    function revealCatalogue() {
      if (loadingState) loadingState.hidden = true;
      root.setAttribute('aria-busy', 'false');
      if (errorState) errorState.hidden = true;
      if (toolbar) toolbar.hidden = false;
      if (grid) grid.hidden = false;
    }

    function showError() {
      if (loadingState) loadingState.hidden = true;
      root.setAttribute('aria-busy', 'false');
      if (toolbar) toolbar.hidden = true;
      if (grid) grid.hidden = true;
      if (emptyState) emptyState.hidden = true;
      if (errorState) errorState.hidden = false;
    }

    function fetchAllFinishesWithImages() {
      return fetchAllFinishes().then(function (list) {
        var gids = list
          .map(function (item) {
            return item.gid;
          })
          .filter(Boolean);
        return resolveImages(gids)
          .catch(function () {
            return {};
          })
          .then(function (images) {
            list.forEach(function (item) {
              var resolved = images[item.gid];
              item.m = resolved ? resolved.url : '';
            });
            return list;
          });
      });
    }

    /* One load, one render: finishes, swatch images and the build index all
       arrive before the catalogue is revealed so the grid, the filters and the
       modal can never disagree about the data set. */
    function loadCatalogue() {
      setLoading(true);
      Promise.all([
        fetchAllFinishesWithImages(),
        loadCaseIndex().catch(function () {
          return null;
        })
      ])
        .then(function (result) {
          var list = result[0] || [];
          if (result[1]) caseIndex = result[1];
          if (!list.length) throw new Error('no_finishes');
          renderData(list);
        })
        .catch(function () {
          showError();
        });
    }

    loadCatalogue();
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (context.matches && context.matches(rootSelector)) roots.push(context);
    context.querySelectorAll(rootSelector).forEach(function (node) {
      roots.push(node);
    });
    roots.forEach(init);
  }

  function start() {
    boot(document);
    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
